import { addClass, removeClass, hasClass } from "../util/misc";

export const showStickyHeader = () => {
  const mimHeaderMobile = document.querySelector("#mimHeaderMobile");
  const mimHeaderDesktop = document.getElementById("mimHeaderDesktop");

  if (!mimHeaderDesktop || !mimHeaderMobile) return;

  let lastScrollTop = 0;
  let hasWhiteText = false;

  if (hasClass(mimHeaderDesktop, "text-white")) {
    hasWhiteText = true;
  }

  window.addEventListener(
    "scroll",
    function () {
      // or window.addEventListener("scroll"....
      const st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st === 0) {
        // at rest...
        removeClass(mimHeaderDesktop, "sticky");
        addClass(mimHeaderDesktop, "relative");
        removeClass(mimHeaderDesktop, "bg-white");
        removeClass(mimHeaderDesktop, "py-5");
        addClass(mimHeaderDesktop, "py-10");

        if (hasWhiteText) {
          addClass(mimHeaderDesktop, "text-white");
          removeClass(mimHeaderDesktop, "text-secondary");
        }

        // on mobile
        removeClass(mimHeaderMobile, "sticky");
        addClass(mimHeaderMobile, "relative");
        removeClass(mimHeaderMobile, "bg-white");
        if (hasWhiteText) {
          addClass(mimHeaderMobile, "text-white");
          removeClass(mimHeaderMobile, "text-secondary");
        }
      } else if (st > lastScrollTop) {
        // downscroll
        removeClass(mimHeaderDesktop, "relative");
        removeClass(mimHeaderDesktop, "sticky");
        removeClass(mimHeaderDesktop, "py-5");
        removeClass(mimHeaderDesktop, "bg-white");

        addClass(mimHeaderDesktop, "py-10");

        // on mobile
        removeClass(mimHeaderMobile, "relative");
        removeClass(mimHeaderMobile, "sticky");
        removeClass(mimHeaderMobile, "bg-white");
      } else {
        // upscroll code
        removeClass(mimHeaderDesktop, "relative");
        addClass(mimHeaderDesktop, "sticky");
        addClass(mimHeaderDesktop, "py-5");
        addClass(mimHeaderDesktop, "bg-white");
        removeClass(mimHeaderDesktop, "py-10");

        if (hasWhiteText) {
          removeClass(mimHeaderDesktop, "text-white");
          addClass(mimHeaderDesktop, "text-secondary");
        }

        // on mobile code
        removeClass(mimHeaderMobile, "relative");
        addClass(mimHeaderMobile, "sticky");
        addClass(mimHeaderMobile, "bg-white");

        if (hasWhiteText) {
          removeClass(mimHeaderMobile, "text-white");
          addClass(mimHeaderMobile, "text-secondary");
        }
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    },
    false
  );
};



// WEBPACK FOOTER //
// ./scripts/sections/menu.js